const STORAGE_KEY = 'impersonation.targetUserId'

function read(): string | null {
  if (typeof sessionStorage === 'undefined') return null
  return sessionStorage.getItem(STORAGE_KEY)
}

let current: string | null = read()

export function getImpersonationTarget(): string | null {
  return current
}

export function setImpersonationTarget(targetUserId: string): void {
  current = targetUserId
  if (typeof sessionStorage !== 'undefined')
    sessionStorage.setItem(STORAGE_KEY, targetUserId)
}

export function clearImpersonationTarget(): void {
  current = null
  if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(STORAGE_KEY)
}
